/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginUserResponseDto
 */
export interface LoginUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    roleId: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    roleName: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginUserResponseDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    language: LoginUserResponseDtoLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    organizationId?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUserResponseDto
     */
    organizationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginUserResponseDto
     */
    permissions: Array<string>;
}


/**
 * @export
 */
export const LoginUserResponseDtoLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type LoginUserResponseDtoLanguageEnum = typeof LoginUserResponseDtoLanguageEnum[keyof typeof LoginUserResponseDtoLanguageEnum];


/**
 * Check if a given object implements the LoginUserResponseDto interface.
 */
export function instanceOfLoginUserResponseDto(value: object): value is LoginUserResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('roleId' in value) || value['roleId'] === undefined) return false;
    if (!('roleName' in value) || value['roleName'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function LoginUserResponseDtoFromJSON(json: any): LoginUserResponseDto {
    return LoginUserResponseDtoFromJSONTyped(json, false);
}

export function LoginUserResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginUserResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'roleId': json['roleId'],
        'roleName': json['roleName'],
        'active': json['active'],
        'language': json['language'],
        'name': json['name'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'permissions': json['permissions'],
    };
}

export function LoginUserResponseDtoToJSON(json: any): LoginUserResponseDto {
    return LoginUserResponseDtoToJSONTyped(json, false);
}

export function LoginUserResponseDtoToJSONTyped(value?: LoginUserResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'roleId': value['roleId'],
        'roleName': value['roleName'],
        'active': value['active'],
        'language': value['language'],
        'name': value['name'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'permissions': value['permissions'],
    };
}

